/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { useTranslation, initReactI18next } from 'react-i18next'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import swal from 'sweetalert'
import { useState, useEffect } from 'react'
import { updateSales, getChild, rejectNego,rejectNegoAll ,updateSalesAll, exportChat, updateNegoAll } from '../../../../api/modules/order'
import { useNavigate } from 'react-router-dom'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import { InputGroup, Spinner } from "react-bootstrap"
import CurrencyInput from "react-currency-input-field"
import Firebase from '../../../../app/services/firebase'
import i18next from 'i18next'
import Accordion from 'react-bootstrap/Accordion'
import { setNestedObjectValues } from "formik"


export function Dropdown1(data:any) {

  const list = data.list
  const roomId = data.roomId
  const sector = data.sector
  const { t } = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [language, setLanguage] = useState<any>()
  // console.log(list,'list');

  interface MessageModel {
    userId?: string
    message: string
    timestamp?: string
    time?: string
    roleFlag? : string
  }

  const [messages, setMessages] = useState<MessageModel[]>([])
  const userId = localStorage.getItem('user-id')
  const credential = localStorage.getItem('credential')
  const [messageRole, setMessageRole] = useState([])
  const [showApprove, setShowApprove] = useState(false)
  const [showApproveGroup, setShowApproveGroup] = useState(false)

  const [showUpdate, setShowUpdate] = useState(false)
  const [showPrompt, setShowPrompt] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [reason, setReason] = useState('')
  const [roleUser, setRoleUser] = useState('')

  const [updateQuantum, setUpdateQuantum] = useState<any>()
  const [updatePrice, setUpdatePrice] = useState(0)
  const [id, setID] = useState('')
  const [idParent, setIdParent] = useState(0)
  const [ides, setIdes] = useState([])
  const navigate = useNavigate()
  const [detail,setDetail] = useState<any>({})
  const [nego, setNego] =useState<any>([])

  const [show2, setShow2] = useState(false)
  const handleClose2 = () => setShow2(false)



  // const orderid = sessionStorage.getItem('order-detail-id')
  // const getDetailorder = async () => {
  //   await getChild(orderid).then(
  //     (res) => {
  //       console.log(res.data.data,"cek")
  //       setDetail(res.data.data)
  //     }
  //     )
  //   }
    // console.log({detail, id , orderid});
  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role_flagg')
      setRoleUser(role)
    }
    role()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
        const getCookie = (name: string) => {
            const value = `; ${document.cookie}`
            const parts = value.split(`; ${name}=`)
            if (parts.length === 2) return parts.pop()?.split(';').shift()
        }
        let language = getCookie('i18next')
        setLanguage(language)
    }, 1000);
    return () => clearInterval(interval);
}, []);

const detailMessage = (history : any, data :any) => {
  let tmpMessage : any = []
  for (const m of history){
    if (m.userId == userId){
      let message = {...m, roleFlag : "SalesAdmin", salesOrg : data.produsen?.code, itemId : data.id, level : 'item', po_number : '', customerId : data.parent[0].customer_id, salesId : userId}
      tmpMessage = [...tmpMessage, message]

    } else {
      let message = {...m,roleFlag : '', salesOrg : data.produsen?.code, itemId : data.id, level : 'item', po_number : '', customerId : data.parent[0].customer_id, salesId : userId, userId : data.parent[0].customer_id}
      tmpMessage = [...tmpMessage, message]

    }

  }
  return tmpMessage
}

  const getDetail = async () => {
    setShowPrompt(true)
    const tmp : any = []
    setMessageRole([])

    if (list.length >= 1){
      let tmpHistory : any = []
      let detailItem : any = {}
      let tmpNego : any = []

      for (const t of list){
        const id = t.id
        tmpNego.push({osd_id : id, fixed_price: null, fixed_quantum: null})
      }
      // console.log(list[0],'list[0]');


     await Promise.all(
      list.map((data:any, index : number)=>(
        // console.log(data,'map data')
        getChild(data.id).then(
          async (res) => {
            // setIdes(res.data.data.id)
            // getDetailorder()
            console.log(tmpNego,'tmpNego')
            setNego(tmpNego)
            tmp.push(res.data.data.id)
            detailItem = res.data.data
            // setDetail(res.data.data)
            setIdParent(res.data.data.parent[0].id)
            console.log(res.data.data,'res');
            const history : any = await Firebase.getHistoryMessages(res.data.data.id.toString())
            // console.log(history,'history');
            if (history.length > 0){
              const tmpMessage = detailMessage(history, res.data.data)
              tmpHistory = [...tmpHistory, tmpMessage]
              console.log('chatt');

            } else {
              console.log('chat array 0');

            }
            // console.log(tmpHistory,'atas');
           }
          )
        ))
      )


      const historyMassage : any = await Firebase.getHistoryMessages(roomId);
      // console.log(detail, 'detail');
      // console.log(list, 'list');

       if (historyMassage.length > 0){
        let tmpMessageP : any = []
        for (const m of historyMassage){
          if (m.userId == userId){
            let message = {...m, roleFlag : "SalesAdmin", salesOrg : detailItem.produsen?.code, itemId : '', level : 'parent', po_number : list[0].po_number, customerId : detailItem.parent[0].customer_id, salesId : userId}
            tmpMessageP = [...tmpMessageP, message]

          } else {
            let message = {...m, roleFlag : '', salesOrg : detailItem.produsen?.code, itemId : '', level : 'parent', po_number : list[0].po_number, customerId : detailItem.parent[0].customer_id, salesId : userId, userId : detailItem.parent[0].customer_id}
            tmpMessageP = [...tmpMessageP, message]

          }

        }

        tmpHistory = [...tmpHistory, tmpMessageP]
      } else {
        console.log('chat array 0');
      }
      setMessageRole(tmpHistory)
    } else {
      const historyMassage : any = await Firebase.getHistoryMessages(roomId);
      // console.log(historyMassage, 'ini historyMassage');

      await getChild(roomId).then(
        (res) => {
          setID(res.data.data.id)
          // getDetailorder()
          setDetail(res.data.data)
          console.log(res.data.data,'res detail');

          const tmpMessage = detailMessage(historyMassage, res.data.data)

          // console.log(tmpMessage, 'tmpMessage');
          if (tmpMessage.length >= 1){
          setMessageRole(tmpMessage)
        } else {
          console.log('chat array 0');

        }

        }
      )
    }
    setIdes(tmp)

    // console.log(ides, 'ides');

  }

  const handleUpdate = async () => {
    // console.log(messageRole, 'messageRole');
    console.log({updatePrice, updateQuantum});
    const chat = {messages : [messageRole]}
    setBtnLoading(true)

    await updateSales(id,{ fixed_price: updatePrice > 0 ? updatePrice : undefined , fixed_quantum: updateQuantum > 0 ? updateQuantum : undefined })
    .then((res) => {
        console.log(res.data)
        if (messageRole.length !== 0){
          exportChat(language, chat)
        }
        swal({
          title: t('dataBerhasilDiupdate'),
          icon: 'success',
        }).then(
          () => {
            setShowUpdate(false)
            navigate('/management/order/all')
          }
        )

      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          console.log('Error', error.message, ' error message')
        }
      })
      setBtnLoading(false)
  }

  // if array length > 0

  // console.log(nego, 'ini')
  const handlechange = (index : any, value : any, type : any) => {
    let tmpNego : any[] =  []
    tmpNego = nego

    if(type == 'Price'){
      tmpNego[index].fixed_price = parseFloat(value)
    } else {
      tmpNego[index].fixed_quantum = parseFloat(value)
    }
    setNego(tmpNego)
  }

  const handleUpdateGoup = async (data:any) => {
    console.log(messageRole, 'messageRole');
    console.log(nego, 'nego');
    console.log(data,"ini data");
    const chat = {messages : messageRole}
    setBtnLoading(true)
    const temp = {
      orders: nego,
      lang : i18next.language
    }
    await updateNegoAll(credential , temp)
    .then((res) => {
      if (messageRole.length !== 0){
        exportChat(language, chat)
      }
        swal({
          title: t('dataBerhasilDiupdate'),
          icon: 'success',
        }).then(
          () => {
            setShowUpdate(false)
            navigate('/management/order/all')
          }
        )

      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          console.log('Error', error.message, ' error message')
        }
      }).finally(() => {
        setBtnLoading(false)
      }
      )
  }

  const handleReject = async () => {
    setBtnLoading(true)
    setReason('')
    console.log(sector);
    if (list.length > 1){
        // console.log({reason,roomId,type : 'all'});
        try {
          const res = await rejectNegoAll(roomId, 'all',credential ,{ reason: reason })
          swal({
                title: t(res.data.message),
                icon: 'success',
              }).then(
                () => {
                  setShowUpdate(false)
                  navigate('/management/order/all')
                }
              )
        } catch (error : any){
        // console.log(error.response.data.message);

          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
    } else {
      // console.log({reason,roomId,type : 'item'});
      try {
        const res = await rejectNego(roomId, 'item', { reason: reason })
        swal({
              title: t(res.data.message),
              icon: 'success',
            }).then(
              () => {
                setShowUpdate(false)
                navigate('/management/order/all')
              }
            )
      } catch (error : any){
        // console.log(error.response.data.message);

        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      }
    }
    setBtnLoading(false)
  }

  const closeModal = (no: any) => {
    if (no == 1) {
      setShowPrompt(false);
      setShowReject(true)
    } else if (no == 2) {
      setShowPrompt(false);
      setShowUpdate(true)
    }
  }

  const handleTotalQuantum = (data: any) => {
    let tmp = 0
    data.map((item:any)=>(
      tmp += parseFloat(item.request_quantum)
    ))
    return tmp
  }

  const handleTotalPrice = (data: any) => {
    let tmp = 0
    data.map((item:any)=>(
      tmp += item.request_price
    ))
    return tmp
  }

  const handleFormat = (data : any) => {
   let value = data?.replace(/,/g, '.')
   return value
  }

  const hadleHide = () => {
    setUpdateQuantum('')
    setUpdatePrice(0)
    setNego([])
  }

  // console.log(messageRole, 'message Role');


  return (
    <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
      <div className='px-7 py-5'>
        <div className='fs-5 text-dark fw-bolder'>{t("Options")}</div>
      </div>

      <div className='separator border-gray-200'></div>

      <div className='px-7 py-5'>
        {/* <div className='mb-10'>
          <label className='form-label fw-bold'>{t('forDetail')}</label>

          <div className='mt-2'>
            <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true'>
              View
            </button>
          </div>
        </div> */}

        {/* <div className='mb-10'>
          <label className='form-label fw-bold'>{t('export')}</label>

          <div className='mt-2'>
            <button
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTSVG
                path='/media/icons/duotune/arrow-down-square-fill.svg'
                className='svg-icon-3' />
            </button>
          </div>
        </div> */}

        {roleUser == null || roleUser == "null" ? (
          <></>
        ) : (
          <div className='mb-10'>
            <label className='form-label fw-bold'>{t("Close Negotiation")}</label>

            <div className='mt-2'>
              <button
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                onClick={() => getDetail()}
              >
                <KTSVG
                  path='/media/icons/duotune/pencil-fill.svg'
                  className='svg-icon-3'
                />
              </button>
            </div>
          </div>
        )}

        {list?.length >= 1 ? (

          <>
              <Modal
                show={showUpdate}
                onHide={() => {
                  setShowUpdate(false)
                  hadleHide()
                }}
                backdrop='static'
                keyboard={false}
                centered
                scrollable
                size='lg'
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('Negotiation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Accordion>
                    {list.map((data: any, _index: any) => (
                      <Accordion.Item eventKey={data?.id}>
                        <Accordion.Header>
                          {data?.id} / {data?.produsen?.name} / {data?.product_name} /{' '}
                          {data?.incoterm1?.code}
                          {data?.incoterm2 == null
                            ? data?.incoterm2_id == null || data?.incoterm2_id == '0'
                              ? ''
                              : ' - ' + data?.incoterm2_id
                            : ' - ' + data?.incoterm2?.code}{' '}
                          /{' '}
                          {data?.provice
                            ? data.province?.region_name + ' - ' + data?.city?.city_name + ' /'
                            : ''}{' '}
                          {i18next.language === 'en'
                            ? data.fixed_quantum?.toLocaleString('en', {maximumFractionDigits: 4}) +
                              ' Ton'
                            : data.fixed_quantum?.toLocaleString('id', {maximumFractionDigits: 4}) +
                              ' Ton'}
                        </Accordion.Header>
                        <Accordion.Body style={{backgroundColor: 'white'}}>
                          {sector == '1' && (
                            <Row>
                            <Col md='6'>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-provinsi')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={data.province?.region_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-kuantum')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={ (() => {
                                      if (!data?.fixed_quantum) {
                                        return " "
                                      } else {
                                        if (i18next.language === 'en'){
                                          return data?.fixed_quantum?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          }) +
                                          ' ' +
                                          'Ton'
                                        } else {
                                          return data?.fixed_quantum?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          }) +
                                          ' ' +
                                          'Ton'
                                        }
                                      }
                                    })()
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t("Shipping Tolerance")}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t("Shipping Tolerance")}
                                    size='sm'
                                    type='text'
                                    id='shipping'
                                    value={(() => {
                                      if (!data?.shipping_tolerance){
                                        return " "
                                      } else {
                                        return data?.shipping_tolerance + "%"
                                      }
                                    })()}
                                    disabled
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data?.payment_type_1_desc)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data?.payment_note)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-5'>
                                <Col md={4}>
                                  <p className='mt-3 fs-6'>{t('Segment')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data?.segment_name}
                                    type='text'
                                    size='sm'
                                    disabled
                                  />
                                </Col>
                              </Row>


                              <Row className='mb-5'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('Update Quantum')}</p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-md'
                                      placeholder={t("Update Quantum")}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value) => { handlechange(_index ,handleFormat(value), 'Quantum') }}
                                      decimalsLimit={3} />
                                    <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-endUser')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      data?.end_user_detail?.name
                                        ? data?.end_user_detail?.name
                                        : data?.end_user
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md='6'>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {data?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        data?.incoterm2_id == null ||
                                        data?.incoterm2_id == '0'
                                          ? ''
                                          : data?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={data?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={data.city?.city_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-2'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      (() => {
                                        if (!data?.fixed_price) {
                                          return " "
                                        } else {
                                          if (i18next.language === 'en'){
                                            return 'Rp' +
                                            parseInt(data?.fixed_price).toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          } else {
                                            return 'Rp' +
                                            parseInt(data?.fixed_price).toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })
                                          }
                                        }
                                      })()
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={data?.include_ppn}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data?.payment_type_2_desc)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.product_spec}
                                    as='textarea' style={{ height: '40px' }}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data?.notes}
                                    type='text'
                                    as='textarea' style={{ height: '40px' }}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-5'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t("Update Price")}</p>
                                </Col>
                                <Col sm={8}>
                                <InputGroup size='sm'>
                                <InputGroup.Text id='basic-addon2' style={{paddingTop: '1px', paddingBottom: '1px'}}><span style={{padding: '0 6px'}}>Rp</span></InputGroup.Text>
                                <CurrencyInput
                                  className='form-control form-control-md'
                                  placeholder={t("Update Price")}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value : any) => { handlechange(_index,value, 'Price')}}
                                  decimalsLimit={3} />
                                  </InputGroup>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          )}

                          {sector == '3' && (
                            <Row>
                            <Col md='6'>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>Sales Org</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.produsen?.name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-incoterm1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.incoterm1?.code}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-jenis')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.product_type_desc}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-kuantum')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      (() => {
                                        if (!data?.fixed_quantum) {
                                          return " "
                                        } else {
                                          if (i18next.language === 'en'){
                                            return data?.fixed_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            }) +
                                            ' ' +
                                            'Ton'
                                          } else {
                                            return data?.fixed_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            }) +
                                            ' ' +
                                            'Ton'
                                          }
                                        }
                                      })()
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t("Shipping Tolerance")}</p>
                                </Col>
                                <Col sm={8}>
                                  <Form.Control
                                    placeholder={t("Shipping Tolerance")}
                                    size='sm'
                                    type='text'
                                    id='shipping'
                                    value={(() => {
                                      if (!data?.shipping_tolerance){
                                        return " "
                                      } else {
                                        return data?.shipping_tolerance + "%"
                                      }
                                    })()}
                                    disabled
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-payment1')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data?.payment_type_1_desc)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data?.payment_note)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('Update Quantum')}</p>
                                </Col>
                                <Col sm={8}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-md'
                                      placeholder={t("Update Quantum")}
                                      decimalSeparator={language === 'en' ? '.' : ','}
                                      groupSeparator={language === 'en' ? ',' : '.'}
                                      onValueChange={(value) => { handlechange(_index ,handleFormat(value), 'Quantum') }}
                                      decimalsLimit={3} />
                                    <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-endUser')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      data?.end_user_detail?.name
                                        ? data?.end_user_detail?.name
                                        : data?.end_user
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md='6'>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-sektor')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data.sector?.name)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col md={8}>
                                  {data?.incoterm2 == null ? (
                                    <Form.Control
                                      value={
                                        data?.incoterm2_id == null ||
                                        data?.incoterm2_id == '0'
                                          ? ''
                                          : data?.incoterm2_id
                                      }
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  ) : (
                                    <Form.Control
                                      value={data?.incoterm2?.code}
                                      type='text'
                                      disabled
                                      size='sm'
                                    />
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-produk')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.product_name}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={
                                      (() => {
                                        if (!data?.fixed_price) {
                                          return " "
                                        } else {
                                          if (i18next.language === 'en'){
                                            return '$' +
                                            parseInt(data?.fixed_price).toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          } else {
                                            return '$' +
                                            parseInt(data?.fixed_price).toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })
                                          }
                                        }
                                      })()
                                    }
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              {/* <Row className='mb-4'>
                                <Col sm={4}>
                                  <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                </Col>
                                <Col sm={8} className='d-flex justify-content-start'>
                                  <Form.Check
                                    reverse
                                    name='ppn'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                    id='ckbox-ppn'
                                    checked={data?.include_ppn}
                                  />
                                </Col>
                              </Row> */}
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data.product_spec}
                                    as='textarea' style={{ height: '40px' }}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={t(data?.payment_type_2_desc)}
                                    type='text'
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t('sub-order-catatan')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    value={data?.notes}
                                    type='text'
                                    as='textarea' style={{ height: '40px' }}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-5'>
                                <Col sm={4} className='d-flex align-items-center'>
                                  <p className='fs-6'>{t("Update Price")}</p>
                                </Col>
                                <Col sm={8}>
                                <InputGroup size='sm'>
                                <InputGroup.Text id='basic-addon2' style={{paddingTop: '1px', paddingBottom: '1px'}}><span style={{padding: '0 6px'}}>$</span></InputGroup.Text>
                                <CurrencyInput
                                  className='form-control form-control-md'
                                  placeholder={t("Update Price")}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value : any) => { handlechange(_index,value, 'Price')}}
                                  decimalsLimit={3} />
                                  </InputGroup>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                  <div className='d-flex justify-content-end mt-5'>
                  <Button size='sm' onClick={() => setShowApproveGroup(true)} disabled={btnLoading}>
                    {t('Deal')}
                  </Button>
                  </div>
                </Modal.Body>
              </Modal>

        </>
        ) : (
          <>
          {sector == 3 ? (
            <Modal show={showUpdate} onHide={() => {
              setShowUpdate(false)
              hadleHide()
              }} centered backdrop='static' size="lg" >
            <Modal.Header closeButton>
            <Modal.Title>{t("Negotiation")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>Sales Org</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.incoterm1?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-kuantum')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        (() => {
                          if (!detail?.fixed_quantum) {
                            return " "
                          } else {
                            if (i18next.language === 'en'){
                              return detail?.fixed_quantum?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) +
                              ' ' +
                              'Ton'
                            } else {
                              return detail?.fixed_quantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) +
                              ' ' +
                              'Ton'
                            }
                          }
                        })()
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t("Shipping Tolerance")}</p>
                  </Col>
                  <Col sm={8}>
                    <Form.Control
                      placeholder={t("Shipping Tolerance")}
                      size='sm'
                      type='text'
                      id='shipping'
                      value={(() => {
                        if (!detail?.shipping_tolerance){
                          return " "
                        } else {
                          return detail?.shipping_tolerance + "%"
                        }
                      })()
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail?.payment_type_1_desc)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail?.payment_note)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('Update Quantum')}</p>
                  </Col>
                  <Col sm={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-md'
                        placeholder={t("Update Quantum")}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value) => { setUpdateQuantum(handleFormat(value)) }}
                        decimalsLimit={3} />
                      <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        detail?.end_user_detail?.name
                          ? detail?.end_user_detail?.name
                          : detail?.end_user
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail.sector?.name)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {detail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          detail?.incoterm2_id == null ||
                          detail?.incoterm2_id == '0'
                            ? ''
                            : detail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={detail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.product_name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        (() => {
                          if (!detail?.fixed_price) {
                            return " "
                          } else {
                            if (i18next.language === 'en'){
                              return '$' +
                              parseInt(detail?.fixed_price).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            } else {
                              return '$' +
                              parseInt(detail?.fixed_price).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                            }
                          }
                        })()
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                {/* <Row className='mb-4'>
                  <Col sm={4}>
                    <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                  </Col>
                  <Col sm={8} className='d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='ppn'
                      className='mt-5 mb-2'
                      type='checkbox'
                      id='ckbox-ppn'
                      checked={detail?.include_ppn}
                    />
                  </Col>
                </Row> */}
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.product_spec}
                      as='textarea' style={{ height: '40px' }}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail?.payment_type_2_desc)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail?.notes}
                      type='text'
                      as='textarea' style={{ height: '40px' }}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t("Update Price")}</p>
                  </Col>
                  <Col sm={8}>
                  <InputGroup size='sm'>
                  <InputGroup.Text id='basic-addon2' style={{paddingTop: '1px', paddingBottom: '1px'}}><span style={{padding: '0 6px'}}>$</span></InputGroup.Text>
                  <CurrencyInput
                    className='form-control form-control-md'
                    placeholder={t("Update Price")}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value : any) => { setUpdatePrice(value)}}
                    decimalsLimit={3} />
                    </InputGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' size='sm'
              onClick={() => {
                setShowUpdate(false)
                setShowPrompt(true)
              }}>
                {t('cancel')}
              </Button>

              {roleUser == 'salesAdmin' ? (
                <Button size='sm' onClick={() => setShowApprove(true)} disabled={btnLoading}>
                {t('Deal')}
              </Button>
              ) : (
                <></>
              )}


            </Modal.Footer>
          </Modal>
          ) : (
            <Modal show={showUpdate} onHide={() => {
              setShowUpdate(false)
              hadleHide()
              }} centered scrollable backdrop='static' size="lg" >
            <Modal.Header closeButton>
            <Modal.Title>{t("Negotiation")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>Sales Org</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.incoterm1?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={detail.province?.region_name}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-kuantum')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        (() => {
                          if (!detail?.fixed_quantum) {
                            return " "
                          } else {
                            if (i18next.language === 'en'){
                              return detail?.fixed_quantum?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) +
                              ' ' +
                              'Ton'
                            } else {
                              return detail?.fixed_quantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) +
                              ' ' +
                              'Ton'
                            }
                          }
                        })()
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t("Shipping Tolerance")}</p>
                  </Col>
                  <Col sm={8}>
                    <Form.Control
                      placeholder={t("Shipping Tolerance")}
                      size='sm'
                      type='text'
                      id='shipping'
                      value={(() => {
                        if (!detail?.shipping_tolerance){
                          return " "
                        } else {
                          return detail?.shipping_tolerance + "%"
                        }
                      })()}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail?.payment_type_1_desc)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail?.payment_note)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-5'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Segment')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail?.segment_name}
                      type='text'
                      size='sm'
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-5'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('Update Quantum')}</p>
                  </Col>
                  <Col sm={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-md'
                        placeholder={t("Update Quantum")}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value) => { setUpdateQuantum(handleFormat(value)) }}
                        decimalsLimit={3} />
                      <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        detail?.end_user_detail?.name
                          ? detail?.end_user_detail?.name
                          : detail?.end_user
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail.sector?.name)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {detail?.incoterm2 == null ? (
                      <Form.Control
                        value={
                          detail?.incoterm2_id == null ||
                          detail?.incoterm2_id == '0'
                            ? ''
                            : detail?.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={detail?.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={detail.city?.city_name}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.product_name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-2'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        (() => {
                          if (!detail?.fixed_price) {
                            return " "
                          } else {
                            if (i18next.language === 'en'){
                              return 'Rp' +
                              parseInt(detail?.fixed_price).toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            } else {
                              return 'Rp' +
                              parseInt(detail?.fixed_price).toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })
                            }
                          }
                        })()
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={4}>
                    <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                  </Col>
                  <Col sm={8} className='d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='ppn'
                      className='mt-5 mb-2'
                      type='checkbox'
                      id='ckbox-ppn'
                      checked={detail?.include_ppn}
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(detail?.payment_type_2_desc)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail.product_spec}
                      as='textarea' style={{ height: '40px' }}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={detail?.notes}
                      type='text'
                      as='textarea' style={{ height: '40px' }}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-5'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t("Update Price")}</p>
                  </Col>
                  <Col sm={8}>
                  <InputGroup size='sm'>
                  <InputGroup.Text id='basic-addon2' style={{paddingTop: '1px', paddingBottom: '1px'}}><span style={{padding: '0 6px'}}>Rp</span></InputGroup.Text>
                  <CurrencyInput
                    className='form-control form-control-md'
                    placeholder={t("Update Price")}
                    decimalSeparator={language === 'en' ? '.' : ','}
                    groupSeparator={language === 'en' ? ',' : '.'}
                    onValueChange={(value : any) => { setUpdatePrice(value)}}
                    decimalsLimit={3} />
                    </InputGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' size='sm'
              onClick={() => {
                setShowUpdate(false)
                setShowPrompt(true)
              }}>
                {t('cancel')}
              </Button>

              {roleUser == 'salesAdmin' ? (
                <Button variant="success" size='sm' onClick={() => setShowApprove(true)} disabled={btnLoading}>
                  {t('Deal')}
                </Button>
              ) : (
                <></>
              )}


            </Modal.Footer>
          </Modal>
          )}
        </>
        )}


        <Modal show={showPrompt} onHide={() => setShowPrompt(false)} centered backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>{t("Closing Negotiation")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className='mb-5'>
              <Col sm={6} className='d-flex justify-content-center'>
                <Button variant='danger' onClick={() => closeModal(1)}>
                  {t("No Deal")}
                </Button>
              </Col>
              <Col sm={6} className='d-flex justify-content-center'>
                <Button variant="success" onClick={() => closeModal(2)}>
                  {t("Deal")}
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal show={showReject} onHide={() => setShowReject(false)} centered backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>{t('Alasan Tolak Negosiasi')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel
              controlId='floatingTextarea2'
              label={t('order-alasan')}
            >
              <Form.Control
                as='textarea'
                placeholder={t("Tinggal-pesan")}
                style={{ height: '100px' }}
                onChange={(e) => setReason(e.target.value)}
              />
            </FloatingLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' size='sm'
            onClick={() => {
              setShowReject(false)
              setShowPrompt(true)
            }}>
              {t('cancel')}
            </Button>
            <Button variant='danger' size='sm' onClick={() => handleReject()} disabled={btnLoading}>
            {
              btnLoading? (
              <Spinner animation='border' variant='light' size='sm' />
              ) : t('No Deal')
            }
           </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showApprove}
          onHide={() => setShowApprove(false)}
          centered
          backdrop='static'
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="border border-top-0 border-bottom-0 border-1 border-secondary">
            <h3 className='text-center mb-5'>{t('Are you sure?')}</h3>
          </Modal.Body>
          <Modal.Footer className="border border-top-1 border-1 border-secondary">
            <Button variant='secondary' onClick={() => setShowApprove(false)}>
              {t('Tidak')}
            </Button>
            <Button onClick={() => handleUpdate()} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('Ya')
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showApproveGroup}
          onHide={() => setShowApproveGroup(false)}
          centered
          backdrop='static'
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="border border-top-0 border-bottom-0 border-1 border-secondary">
            <h3 className='text-center mb-5'>{t('Are you sure?')}</h3>
          </Modal.Body>
          <Modal.Footer className="border border-top-1 border-1 border-secondary">
            <Button variant='secondary' onClick={() => setShowApproveGroup(false)}>
              {t('Tidak')}
            </Button>
            <Button variant="success" onClick={() => handleUpdateGoup(list)} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('Ya')
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  )
}
